import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import IconBlockData from 'app/Models/Content/IconBlockData';
import InternetLobbyProductBlockData from 'app/Models/Content/InternetLobbyProductBlockData';
import MarketingTextBlockData from 'app/Models/Content/MarketingTextBlockData';
import React from 'react';
import Arrow from '../../Shared/Arrow';
import {getTextWithHighlight} from 'app/utilities/highlightText';
import {getImageProps} from 'app/utilities/ImageProps';

const InternetLobbyProductBlock = ({data, context}: ComponentProps<InternetLobbyProductBlockData>) => (
  <div className='InternetLobbyProductBlock'>
    <a href={data.buttonLink.value}>
      <Image {...getImageProps(data.image, context)} />

      {data.title.expandedValue.map(({text, highlightText}: MarketingTextBlockData, i) => (
        <h3 key={i}>{getTextWithHighlight({text: text.value, highlightText: highlightText.value})}</h3>
      ))}

      <div className={`InternetLobbyProductBlock__iconsBlock-${data.icons.expandedValue.length % 2 == 0 ? `even` : `odd`}`}>
        {data.icons.expandedValue.map(({description}: IconBlockData, i) => (
          <span
            key={i}
            className={`InternetLobbyProductBlock__iconsBlock-${data.icons.expandedValue.length % 2 == 0 ? `even` : `odd`}__description`}>
            {description.value}
          </span>
        ))}
      </div>

      <div className='InternetLobbyProductBlock__price-and-button'>
        <div className='InternetLobbyProductBlock__price-and-button__price-and-label'>
          <div className='InternetLobbyProductBlock__price-and-button__price-and-label__price-and-ils'>
            <span className='InternetLobbyProductBlock__price-and-button__price-and-label__price-and-ils__price'>{data.price.value}</span>

            <span className='InternetLobbyProductBlock__price-and-button__price-and-label__price-and-ils__ils'>₪</span>
          </div>

          <span className='InternetLobbyProductBlock__price-and-button__price-and-label__label'>{data.priceLabel.value}</span>
        </div>

        <div className='InternetLobbyProductBlock__price-and-button__button'>{data.buttonLinkTitle.value}</div>
      </div>

      <div className='InternetLobbyProductBlock__note'>
        <span className='InternetLobbyProductBlock__note'>{data.note.value}</span>
      </div>
    </a>

    <a href={data.packageTermsLink.value} className='InternetLobbyProductBlock__terms'>
      {data.packageTermsLinkTitle.value}

      <Arrow className='InternetLobbyProductBlock__terms__arrow' />
    </a>
  </div>
);

export default InternetLobbyProductBlock;
